import ServiceDirectoryPage from "./ServiceDirectoryPage"

const DirectoryWrapper = () => {
  return (
    <ServiceDirectoryPage isNationalHelplines={false} />
  );
}

export default DirectoryWrapper;